import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import InviteWASelfProvisionContent from '../components/pages/waiting-area/invite-self-provision/content';

function InviteWASelfProvisionPage(props) {
  const showWaitingAreaSelfProvisionModal = useSelector(
    (state) => state.modalReducer.showWaitingAreaSelfProvisionModal
  );
  const selectedUsers = useSelector((state) => state.usersReducer.searchSelectUsersForm.selectedUsers || []);
  const timezone = useSelector((state) => state.usersReducer.userProfile.timezoneOffsetNow);
  const userName = useSelector(
    (state) => state.usersReducer.userProfile.firstName + ' ' + state.usersReducer.userProfile.lastName
  );

  const dispatch = useDispatch();

  return (
    <div>
      <InviteWASelfProvisionContent
        showWaitingAreaSelfProvisionModal={showWaitingAreaSelfProvisionModal}
        selectedUsers={selectedUsers}
        dispatch={dispatch}
        timezone={timezone}
        userName={userName}
      />
    </div>
  );
}

export default InviteWASelfProvisionPage;
